const o=1024,t="80",c="80",e="48",n="48";export{c as DESKTOP_IMG_HEIGHT,t as DESKTOP_IMG_WIDTH,o as LARGE_BREAKPOINT,n as MOBILE_IMG_HEIGHT,e as MOBILE_IMG_WIDTH};
